import React, { useEffect, useState } from 'react'
import { useApp } from '../../context/AppContext'
import { supabase } from '../../lib/supabase'
import './Calendar.css'

const LUNI = ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie','Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie']
const ZILE_SAPTAMANA = ['Lu','Ma','Mi','Jo','Vi','Sa','Du']

export default function Calendar() {
  const { user, profile } = useApp()
  const [progres, setProgres] = useState({})
  const [luna, setLuna] = useState(new Date().getMonth())
  const [an, setAn] = useState(new Date().getFullYear())
  const [ziSelectata, setZiSelectata] = useState(null)
  const [stats, setStats] = useState({ total: 0, streakCurent: 0, streakMax: 0 })
  const [loading, setLoading] = useState(true)

  const today = new Date().toISOString().split('T')[0]
  const financiar = profile?.profil_financiar

  useEffect(() => { loadProgres() }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function loadProgres() {
    const { data } = await supabase
      .from('progres_zilnic').select('*')
      .eq('user_id', user.id).order('data', { ascending: true })
    if (data) {
      const map = {}
      data.forEach(z => { map[z.data] = z })
      setProgres(map)
      calcStats(data)
    }
    setLoading(false)
  }

  function calcStats(zile) {
    const total = zile.filter(z => z.zile_fara_joc).length
    let streakCurent = 0
    const desc = [...zile].sort((a, b) => b.data.localeCompare(a.data))
    for (const z of desc) { if (z.zile_fara_joc) streakCurent++; else break }
    let streakMax = 0, tmp = 0
    const asc = [...zile].sort((a, b) => a.data.localeCompare(b.data))
    for (const z of asc) {
      if (z.zile_fara_joc) { tmp++; streakMax = Math.max(streakMax, tmp) }
      else tmp = 0
    }
    setStats({ total, streakCurent, streakMax })
  }

  async function bifaAzi() {
    await supabase.from('progres_zilnic').upsert({ user_id: user.id, data: today, zile_fara_joc: true })
    loadProgres()
  }

  function getZileLuna() {
    const primaZi = new Date(an, luna, 1)
    const ultimaZi = new Date(an, luna + 1, 0)
    const ziStart = (primaZi.getDay() + 6) % 7
    const zile = []
    for (let i = 0; i < ziStart; i++) zile.push(null)
    for (let d = 1; d <= ultimaZi.getDate(); d++) {
      zile.push(`${an}-${String(luna+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`)
    }
    return zile
  }

  function navLuna(dir) {
    let l = luna + dir, a = an
    if (l < 0) { l = 11; a-- }
    if (l > 11) { l = 0; a++ }
    setLuna(l); setAn(a)
  }

  function getZiClass(dateStr) {
    if (!dateStr) return 'zi-empty'
    if (dateStr > today) return 'zi-viitor'
    if (dateStr === today) return progres[dateStr]?.zile_fara_joc ? 'zi-today zi-bifata' : 'zi-today'
    return progres[dateStr]?.zile_fara_joc ? 'zi-bifata' : 'zi-ratata'
  }

  const baniEconomisiti = Math.round(stats.total * (financiar?.buget_zilnic_joc || 20))
  const ziuaDeAziBifata = progres[today]?.zile_fara_joc

  if (loading) return <div className="loading-screen">Se incarca...</div>

  return (
    <div className="calendar-page">
      <div className="cal-stats">
        <div className="cal-stat"><div className="cal-stat-num" style={{color:'var(--green)'}}>{stats.streakCurent}</div><div className="cal-stat-lbl">zile consecutive</div></div>
        <div className="cal-stat"><div className="cal-stat-num">{stats.total}</div><div className="cal-stat-lbl">total zile libere</div></div>
        <div className="cal-stat"><div className="cal-stat-num">{stats.streakMax}</div><div className="cal-stat-lbl">record personal</div></div>
        <div className="cal-stat"><div className="cal-stat-num" style={{color:'var(--teal)'}}>{baniEconomisiti} lei</div><div className="cal-stat-lbl">economisiti</div></div>
      </div>

      {!ziuaDeAziBifata ? (
        <div className="cal-bifa-azi">
          <div><div className="cal-bifa-title">Nu ai jucat azi?</div><div className="cal-bifa-sub">Bifa ziua si mentine streak-ul!</div></div>
          <button className="btn-primary" onClick={bifaAzi}>Bifa ziua ✓</button>
        </div>
      ) : (
        <div className="cal-bifa-done">
          <span className="bifa-check">✓</span>
          <div><div className="cal-bifa-title" style={{color:'var(--green)'}}>Ziua de azi bifata!</div><div className="cal-bifa-sub">Streak: {stats.streakCurent} zile 🔥</div></div>
        </div>
      )}

      <div className="cal-card">
        <div className="cal-nav">
          <button className="cal-nav-btn" onClick={() => navLuna(-1)}>←</button>
          <span className="cal-nav-title">{LUNI[luna]} {an}</span>
          <button className="cal-nav-btn" onClick={() => navLuna(1)}>→</button>
        </div>
        <div className="cal-grid-header">
          {ZILE_SAPTAMANA.map(z => <div key={z} className="cal-header-day">{z}</div>)}
        </div>
        <div className="cal-grid">
          {getZileLuna().map((dateStr, i) => (
            <div key={i} className={`cal-zi ${getZiClass(dateStr)}`}
              onClick={() => dateStr && dateStr <= today && setZiSelectata(dateStr)}>
              {dateStr && <>
                <span className="zi-nr">{parseInt(dateStr.split('-')[2])}</span>
                {progres[dateStr]?.zile_fara_joc && <span className="zi-check">✓</span>}
              </>}
            </div>
          ))}
        </div>
        <div className="cal-legenda">
          <span className="legenda-item"><span className="legenda-dot dot-bifata"/>Zi libera</span>
          <span className="legenda-item"><span className="legenda-dot dot-today"/>Azi</span>
          <span className="legenda-item"><span className="legenda-dot dot-ratata"/>Ratata</span>
          <span className="legenda-item"><span className="legenda-dot dot-viitor"/>Urmeaza</span>
        </div>
      </div>

      {ziSelectata && (
        <div className="zi-popup-overlay" onClick={() => setZiSelectata(null)}>
          <div className="zi-popup" onClick={e => e.stopPropagation()}>
            <button className="zi-popup-close" onClick={() => setZiSelectata(null)}>×</button>
            <div className="zi-popup-data">{new Date(ziSelectata + 'T12:00:00').toLocaleDateString('ro-RO', {weekday:'long',day:'numeric',month:'long'})}</div>
            {progres[ziSelectata]?.zile_fara_joc
              ? <><div className="zi-popup-status" style={{color:'var(--green)'}}>✓ Zi libera</div><div className="zi-popup-economii">+{financiar?.buget_zilnic_joc || 20} lei economisiti</div></>
              : <div className="zi-popup-status" style={{color:'var(--red)'}}>✗ Nu a fost bifata</div>}
            {progres[ziSelectata]?.jurnal_text && (
              <div className="zi-popup-jurnal"><div className="zi-popup-jurnal-label">Jurnal</div><p>{progres[ziSelectata].jurnal_text}</p></div>
            )}
            {progres[ziSelectata]?.slot_sesiune && (
              <div className="zi-popup-slot">
                <div className="zi-popup-jurnal-label">Sesiune simulator</div>
                <p>Pierdut: {progres[ziSelectata].slot_sesiune.pierderi_totale} lei · Spinuri: {progres[ziSelectata].slot_sesiune.spinuri_folosite}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
